import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import store from '../../store';
import { resetFormFieldError, resetTempFormUpdateData } from '../formReducer';

export const PasswordField = ({ fielddata, value, setValue, getValues, errors, clearErrors, setError, formId }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [customError, setCustomError] = useState(null);
  const [val, setVal] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    if (val !== null) {
      setValue(fielddata.name, val);
      dispatch(resetTempFormUpdateData({ formId, fieldName: fielddata.name }))
    }
  }, [val])

  //////////////////////////////////////// Effect the field error from outside //////////////////////////////
  useEffect(() => {
    if (customError !== null) {
      setError(fielddata.name, customError);
      dispatch(resetFormFieldError({ formId, fieldName: fielddata.name }))
    }
  }, [customError]);

  store.subscribe(() => {
    const storeData = store.getState();

    if (Object.keys(storeData.formSlice.tempFormUpdateData).length > 0 && storeData.formSlice.tempFormUpdateData[formId] !== undefined && storeData.formSlice.tempFormUpdateData[formId][fielddata.name] !== undefined) {
      console.log("storing====>")
      setVal(storeData.formSlice.tempFormUpdateData[formId][fielddata.name])
    }

    //////////////////////////////////////////// Set Error from Outside ///////////////////////////////////////////////////////////
    if (Object.keys(storeData.formSlice.tempFormFieldError).length > 0 && storeData.formSlice.tempFormFieldError[formId] !== undefined && storeData.formSlice.tempFormFieldError[formId][fielddata.name] !== undefined) {
      console.log("storing====>")
      setCustomError(storeData.formSlice.tempFormFieldError[formId][fielddata.name])
    }
  })

  return (
    <div className={fielddata.className}>
      {/* HEADING */}
      {fielddata.heading && <InputLabel ><div dangerouslySetInnerHTML={{ __html: fielddata.heading }}></div></InputLabel>}
      {/* FIELD */}
      <FormControl >
        {fielddata.label && <InputLabel >{fielddata.label}</InputLabel>}
        <OutlinedInput
          type={showPassword ? 'text' : 'password'}
          value={getValues(fielddata.name) ? getValues(fielddata.name) : ""}
          onChange={(e) => {
            setValue(fielddata.name, e.target.value);
            if (fielddata.name === "confirmPassword" && e.target.value !== "" && getValues("password") !== undefined && getValues("password") !== e.target.value) {
              console.log('e++++++++++++++++++++++++++', e.target.value, getValues("password"));
              setError(fielddata.name, { type: "errorMessageConfirmPassword" });
            }else{
              clearErrors(fielddata.name); // Clearing errors on focus or change

            }
          }}
          /////////////////////////////// For Confirm Password /////////////////////////
          onBlur={(e) => {
            if (fielddata.name === "confirmPassword" && e.target.value !== "" && getValues("password") !== undefined && getValues("password") !== e.target.value) {
              console.log('e++++++++++++++++++++++++++', e.target.value, getValues("password"));
              setError(fielddata.name, { type: "errorMessageConfirmPassword" });
            }
          }}
          label={fielddata.label}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        {/* ERROR */}
        {errors[fielddata.name]?.type && <FormHelperText sx={{ color: 'red' }}>{fielddata.errorMessage[errors[fielddata.name].type]}</FormHelperText>}
      </FormControl>
    </div>
  )
}